import { CSSProperties } from 'react'

import { cn } from '@/lib/utils'

type HeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' // The HTML element to render the heading as
  size: 1 | 2 | 3 | 4 | 5 | 6
  className?: string
  style?: CSSProperties
  children: React.ReactNode
}

export function Heading({
  as,
  size,
  className,
  children,
  style,
}: HeadingProps) {
  // @todo: Not sure why we need to the !important modified for the leading
  // class to be picked up
  const commonClass = 'mt-0 mb-2 font-medium text-black leading-[1.2]!'

  const headingLevelClassNames = {
    1: 'text-[26px] leading-[1.3]!',
    2: 'text-[23px]',
    3: 'text-[20px]',
    4: 'text-[16.5px]',
    5: 'text-body-base',
    6: 'text-body-base',
  }

  const headingLevelClassName = headingLevelClassNames[size]

  const Tag: React.ElementType = as ?? `h${size}`

  const finalClass = cn(commonClass, headingLevelClassName, className)

  return (
    <Tag className={finalClass} style={style}>
      {children}
    </Tag>
  )
}
